import { Popover } from '@/components/utils/Popover/Popover';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, IconButton, Stack, TextField, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

type LinkSettingsPopoverProps = {
    link: string;
};

interface Props {
    anchorEl: HTMLElement | null;
    value: LinkSettingsPopoverProps;
    onClose: () => void;
    onUpdate: (settings: LinkSettingsPopoverProps) => void;
    slotProps?: { paper?: { sx?: object; ref: React.Ref<HTMLDivElement> } };
}

export const LinkSettingsPopover: React.FC<Props> = ({ anchorEl, onClose, onUpdate, value, slotProps }) => {
    const { t } = useTranslation();

    const open = Boolean(anchorEl);

    return (
        <Popover
            title={t('slide.asset.link')}
            open={open}
            anchorEl={anchorEl}
            onClose={() => onClose()}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: -8,
                horizontal: 'center',
            }}
            slotProps={slotProps}
        >
            <Stack spacing={1}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <TextField
                        label={t('slide.asset.link')}
                        type='text'
                        size='small'
                        defaultValue={value.link || ''}
                        onChange={(e) => {
                            let link = e.target.value;
                            if (link && !link.startsWith('http://') && !link.startsWith('https://')) {
                                link = `https://${link}`;
                            }
                            onUpdate?.({ ...value, link });
                        }}
                        slotProps={{ input: { minRows: 8, maxRows: 72 } }}
                        sx={{ width: 300 }}
                    />

                    <Tooltip title={t('common.open')}>
                        <IconButton
                            disabled={!value.link.trim()}
                            onClick={() => {
                                window.open(value.link, '_blank');
                            }}
                        >
                            <OpenInNewIcon fontSize='small' />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Stack>
        </Popover>
    );
};
